 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"buy-nft~my-nft~onboard":"buy-nft~my-nft~onboard","buy-nft~my-nft":"buy-nft~my-nft","buy-nft":"buy-nft","my-nft":"my-nft","onboard":"onboard"}[chunkId]||chunkId) + "." + {"buy-nft~my-nft~onboard":"1d02e807","buy-nft~my-nft":"815752d6","buy-nft":"68f2ffa4","my-nft":"dee0135c","onboard":"3172ddf2","chunk-16f8fd7e":"d095a332","chunk-2d0b3819":"06a34f85","chunk-2d0b6396":"ddc55800","chunk-2d0a3af6":"c644ec83","chunk-2d0aa92a":"0adce830","chunk-2d0ab1a6":"252d69e0","chunk-2d0ae558":"ecda85db","chunk-2d0aef17":"27d4fd7b","chunk-2d0b2214":"4691c4c8","chunk-2d0b631d":"f795024a","chunk-2d0b64fd":"129bf7c9","chunk-2d0c55e7":"38bff2ae","chunk-2d0c81dc":"dbee6ce4","chunk-2d0c9559":"87abf571","chunk-2d0d2b80":"a976ba97","chunk-2d0d2eff":"65385136","chunk-2d0d3114":"06f1f073","chunk-2d0d34c2":"2e4cb979","chunk-2d0d8397":"cba1a305","chunk-2d0dd82a":"aa4e777c","chunk-2d0ddfb4":"bd1844fb","chunk-2d0e1793":"0659d41e","chunk-2d0e19f3":"5754dcf3","chunk-2d0e2541":"25c757cd","chunk-2d0e2c5a":"4dbab7e6","chunk-2d0e456c":"9272e78a","chunk-2d0e523e":"c5ac3736","chunk-2d0e625b":"49658593","chunk-2d0e6304":"413e3450","chunk-2d0e99bf":"8a1469ec","chunk-2d0e9b54":"58d77dbf","chunk-2d0e9cd6":"cd04a841","chunk-2d0ea0b6":"16426957","chunk-2d0f006e":"bc0d53c5","chunk-2d0f03c5":"98793f03","chunk-2d208aa8":"09dc62a2","chunk-2d208c0c":"f0876737","chunk-2d20fb37":"ed3e9f2e","chunk-2d20ff24":"d2ff4f12","chunk-2d210b9e":"4bb196a1","chunk-2d2131b3":"1ea1116f","chunk-2d215cff":"f6df7a64","chunk-2d2170dd":"5af94ae9","chunk-2d217507":"1c35f40f","chunk-2d217899":"24c77fe9","chunk-2d217a6c":"e6ab4057","chunk-2d21b297":"199536dc","chunk-2d21d06a":"ef760962","chunk-2d21e768":"fa1f9b0a","chunk-2d2219e3":"063c81e9","chunk-2d221c7f":"9ca326cc","chunk-2d224cff":"18e92830","chunk-2d225271":"acba1418","chunk-2d229045":"379f86e0","chunk-2d22e0b9":"1de01b46","chunk-2d230151":"515042ae","chunk-2d230668":"5f9c6610","chunk-2d237502":"b960d998","chunk-2d237711":"0be1cc8b","chunk-69339e99":"66e37917","chunk-74774a2b":"c2d7eee0","chunk-76f1ae09":"0b30d41e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"buy-nft~my-nft":1,"buy-nft":1,"my-nft":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"buy-nft~my-nft~onboard":"buy-nft~my-nft~onboard","buy-nft~my-nft":"buy-nft~my-nft","buy-nft":"buy-nft","my-nft":"my-nft","onboard":"onboard"}[chunkId]||chunkId) + "." + {"buy-nft~my-nft~onboard":"31d6cfe0","buy-nft~my-nft":"96082b46","buy-nft":"b99643ad","my-nft":"25889edd","onboard":"31d6cfe0","chunk-16f8fd7e":"31d6cfe0","chunk-2d0b3819":"31d6cfe0","chunk-2d0b6396":"31d6cfe0","chunk-2d0a3af6":"31d6cfe0","chunk-2d0aa92a":"31d6cfe0","chunk-2d0ab1a6":"31d6cfe0","chunk-2d0ae558":"31d6cfe0","chunk-2d0aef17":"31d6cfe0","chunk-2d0b2214":"31d6cfe0","chunk-2d0b631d":"31d6cfe0","chunk-2d0b64fd":"31d6cfe0","chunk-2d0c55e7":"31d6cfe0","chunk-2d0c81dc":"31d6cfe0","chunk-2d0c9559":"31d6cfe0","chunk-2d0d2b80":"31d6cfe0","chunk-2d0d2eff":"31d6cfe0","chunk-2d0d3114":"31d6cfe0","chunk-2d0d34c2":"31d6cfe0","chunk-2d0d8397":"31d6cfe0","chunk-2d0dd82a":"31d6cfe0","chunk-2d0ddfb4":"31d6cfe0","chunk-2d0e1793":"31d6cfe0","chunk-2d0e19f3":"31d6cfe0","chunk-2d0e2541":"31d6cfe0","chunk-2d0e2c5a":"31d6cfe0","chunk-2d0e456c":"31d6cfe0","chunk-2d0e523e":"31d6cfe0","chunk-2d0e625b":"31d6cfe0","chunk-2d0e6304":"31d6cfe0","chunk-2d0e99bf":"31d6cfe0","chunk-2d0e9b54":"31d6cfe0","chunk-2d0e9cd6":"31d6cfe0","chunk-2d0ea0b6":"31d6cfe0","chunk-2d0f006e":"31d6cfe0","chunk-2d0f03c5":"31d6cfe0","chunk-2d208aa8":"31d6cfe0","chunk-2d208c0c":"31d6cfe0","chunk-2d20fb37":"31d6cfe0","chunk-2d20ff24":"31d6cfe0","chunk-2d210b9e":"31d6cfe0","chunk-2d2131b3":"31d6cfe0","chunk-2d215cff":"31d6cfe0","chunk-2d2170dd":"31d6cfe0","chunk-2d217507":"31d6cfe0","chunk-2d217899":"31d6cfe0","chunk-2d217a6c":"31d6cfe0","chunk-2d21b297":"31d6cfe0","chunk-2d21d06a":"31d6cfe0","chunk-2d21e768":"31d6cfe0","chunk-2d2219e3":"31d6cfe0","chunk-2d221c7f":"31d6cfe0","chunk-2d224cff":"31d6cfe0","chunk-2d225271":"31d6cfe0","chunk-2d229045":"31d6cfe0","chunk-2d22e0b9":"31d6cfe0","chunk-2d230151":"31d6cfe0","chunk-2d230668":"31d6cfe0","chunk-2d237502":"31d6cfe0","chunk-2d237711":"31d6cfe0","chunk-69339e99":"31d6cfe0","chunk-74774a2b":"31d6cfe0","chunk-76f1ae09":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
